import { useContext } from 'react';
import EditSessionContext from './EditSessionContext';
const EditSessionRender = ({ children }) => {
    const { isEditSessionActive } = useContext(EditSessionContext);
    return isEditSessionActive ? children : null;
};
export default EditSessionRender;
